import BaseModel from "./BaseModel";
import User from "./User";

/**
 * Rules handler and definition
 */
export default class Rules extends BaseModel{
  
  constructor(userStatus = null, uri = null) {
    super();
    this.baseUser = new User({});
    this.setRules();

    this.userStatus = userStatus;
    this.uri = uri;
  }

  setRules() {
    this.rules = {};

    this.rules[this.baseUser.userStatus.ADMIN] = [
      '/admin/dashboard'
    ];

    this.rules[this.baseUser.userStatus.STUDENT] = [
      '/dashboard'
    ];

    this.rules[this.baseUser.userStatus.FULL_STUDENT] = [
      '/dashboard'
    ];
  }

  getBaseRoute() {
    const baseStudentPath = '/dashboard';
    const baseAdminPath = '/admin/dashboard';

    return this.userStatus == this.baseUser.userStatus.STUDENT ? baseStudentPath : baseAdminPath;
  }

  /**
   * Checks if logged User can access route by its status
   * @returns {boolean}
   */
  canShow() {
    if (this.userStatus == null || this.uri == null) {
      return false;
    }
    
    if (
      !this.rules[this.userStatus].includes(this.uri)
    ) {
      return false;
    }
    return true;
  }
}